module.exports = __webpack_public_path__ + "img/孔若楠.56ea4f46.jpg";